import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLowerContentList } from '../../../../../../../Redux/slices/certificate';

//
import Image from '../../../molecules/Image';
import Signature from '../../../molecules/Signature/Signature';

//

function Box({ boxContent, index, preview }) {
  const dispatch = useDispatch();

  const { imgSrc, isVisible, name, post, nameColor, postColor, nameFontSize, postFontSize } =
    boxContent;

  const [showImage, setShowImage] = useState(false);
  const [showSignature, setShowSignature] = useState(false);

  const handleShowImage = () => setShowImage(true);
  const handleCloseImage = () => setShowImage(false);

  const handleCloseSignature = () => setShowSignature(false);
  const handleShowSignature = () => setShowSignature(true);

  const handleSaveImage = (imageData) => {
    dispatch(
      setLowerContentList({
        index: index,
        data: { imgSrc: imageData.file }
      })
    );
  };

  const handleSaveSignature = (signatureData) => {
    console.log(signatureData, 'signatureData');
    dispatch(
      setLowerContentList({
        index: index,
        data: signatureData
      })
    );
  };

  return (
    <div className={`${preview ? '' : 'c-container'} p-3`}>
      {!name && (
        <div>
          <Image
            show={showImage}
            imgSrc={imgSrc}
            isVisible={isVisible}
            handleShow={handleShowImage}
            handleSave={handleSaveImage}
            handleClose={handleCloseImage}
          />
        </div>
      )}

      <br />

      {!imgSrc && (
        <div>
          <Signature
            title="Signature"
            signature={boxContent}
            show={showSignature}
            name={name}
            post={post}
            nameColor={nameColor}
            postColor={postColor}
            nameFontSize={nameFontSize}
            postFontSize={postFontSize}
            //
            handleSave={handleSaveSignature}
            handleShow={handleShowSignature}
            handleClose={handleCloseSignature}
          />
        </div>
      )}
    </div>
  );
}

export default Box;
